export const faqData = {
  en: [
    {
      id: 1,
      title: "What’s Darayish ?",
      description:
        "- From the child's side: It is an interactive application dedicated to children that helps the child express his opinions and the details of his day by addressing an interactive cartoon character that talks to him and answers his questions \n - From the father's side: It is an interactive application dedicated to children that helps the child express his opinions and the details of his day by addressing an interactive cartoon character. And enabling the father to view the child's opinions and questions and answer them by sending text and voice messages to that character without the child knowing.",
    },
    {
      id: 2,
      title: "How to use Draiesh ?",
      description:
        "- From the father's side: You can create a new account and add a child by scanning the QR code that is generated on the son's account when downloading the application for the first time \n - The child can talk to the cartoon character by going to the talk section and he can also use the games in the games section",
    },
    {
      id: 3,
      title: "What type of content is exchanged on Draiesh ?",
      description:
        "- From the child's side: The child can talk in Arabic and English with a new cartoon friend \n - From the father's side: You can send text or voice messages in both languages so that the cartoon character can read them from the child's side of the application",
    },
  ],
};
